import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const aadharApi = createAsyncThunk(
  "aadhar",
  async ({ name = "", startDate = "", endDate = "" }) => {
    const params = {};

    // Add name to the query if provided
    if (name) {
      params.name = name;
    }

    // Add date range to the query if provided
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }

    const response = await axiosInstance.get("/adhars", {
      params, // Pass the parameters to the API request
    });
    if (response) {
      return response.data;
    }
  }
);

const aadharSlice = createSlice({
  name: "aadhar",
  initialState: {
    aadhar: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(aadharApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(aadharApi.fulfilled, (state, action) => {
        state.aadhar = action.payload;
        state.loading = false;
      })
      .addCase(aadharApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default aadharSlice.reducer;
